import styled, { css } from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 15px;

  .attendance-periods-header {
    width: calc(100% - 150px);
    margin: 8px 0 0 150px;
    display: grid;
    grid-template-columns: repeat(2, minmax(220px, 600px));
    gap: 20px;
    max-width: 600px;
  }

  .period-title {
    color: var(--color-gray-text);
    font-size: 14px;
    font-weight: 500;
    line-height: 18px;
    max-width: 300px;
    text-align: center;
  }

  .toggles-container {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 56px;
  }

  .checkbox-list {
    display: flex;
    gap: 26px;
    margin-top: 15px;
  }
`;

export const AttendanceDays = styled.div`
  width: 100%;
  padding-bottom: 25px;

  .attendance-days {
    width: 100%;
    display: grid;
    grid-template-columns: 100px minmax(500px, 1fr);
    align-items: flex-start;
    gap: 50px;
    margin-top: 16px;

    .field-holder {
      margin-right: 20px;
    }

    .periods-container {
      display: grid;
      grid-template-columns: repeat(2, minmax(220px, 300px));
      gap: 20px;
    }

    .period-group {
      display: flex;
      flex-direction: column;
      gap: 8px;
    }

    .period-title {
      display: none;
    }

    .period-inputs {
      display: grid;
      grid-template-columns: repeat(2, minmax(130px, 1fr));
      gap: 12px;
    }

    label {
      white-space: nowrap;
      font-weight: 500;
      color: var(--color-gray-text);
    }
  }
`;

export const CheckboxSublist = styled.div<{ height: number }>`
  ${({ height }) =>
    css`
      height: ${height ? `${height + 20}px` : "initial"};
    `};

  &.checkbox-units {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
  }
`;
